import type { User } from '@supabase/supabase-js'

interface AdminAuthVerifier {
  getUser: () => Promise<{ data: { user: User | null }; error: unknown }>
}

export function isAdminUser(user: User | null): boolean {
  return user?.app_metadata?.role === 'admin'
}

export async function verifyAdminUserAccess(auth: AdminAuthVerifier): Promise<boolean> {
  const { data, error } = await auth.getUser()
  return !error && isAdminUser(data.user)
}
